import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as taskService from "../../services/taskService";
import { handleApiError } from "../storeEffects";
import { TaskAction, taskFailure, taskSuccess } from "./storeTask";

export type TaskThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, TaskAction>

export const getTaskPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return taskService.getTaskPage()
        .then(
            taskPage => {
                dispatch(taskSuccess(taskPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(taskFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};